<template>
  <fragment>
    <mc-app-header title="Add Order"> </mc-app-header>
    <mc-app-body>
      <div class="add-order section">
        <b-steps v-model="activeStep" :has-navigation="false">
          <b-step-item
            label="User Details"
            :type="{ 'is-success': true }"
            icon="account-search"
          >
            <div class="mc-container">
              <b-field label="Select Users :">
                <mc-user-select
                  v-model="order.users"
                  multiple
                  :filters="'master:true'"
                />
              </b-field>
              <div class="buttons">
                <b-button
                  :disabled="!usersSelected"
                  class="button"
                  icon-right="chevron-right"
                  @click.prevent="activeStep += 1"
                >
                  Continue
                </b-button>
              </div>
            </div>
          </b-step-item>
          <b-step-item
            label="Plan Details"
            :type="{ 'is-success': true }"
            icon="tag-text-outline"
          >
            <div class="mc-container">
              <b-field label="Plan Name">
                <b-input
                  v-model="order.plan.name"
                  icon="format-title"
                  placeholder="Enter Plan Name"
                ></b-input>
              </b-field>
              <b-notification
                type="is-warning"
                has-icon
                aria-close-label="Close notification"
                role="alert"
              >
                If the user has more than 1000 classes then the number of
                classes will not be decrimented upon scheduling of a class. As
                such user will be considered to be having `unlimited classes`
                and even the UI's will show number of classes remaining as
                `unlimited`.
              </b-notification>
              <b-field label="No of Classes">
                <b-input
                  v-model.number="order.plan.noOfClasses"
                  icon="school"
                  type="number"
                  placeholder="0"
                  expanded
                ></b-input>
              </b-field>
              <b-field label="Amount (in Paisa)">
                <b-input
                  v-model.number="order.plan.amount"
                  icon="currency-inr"
                  type="number"
                  placeholder="Enter amount in Paisa"
                ></b-input>
              </b-field>
              <div class="buttons">
                <b-button
                  class="button"
                  icon-left="chevron-left"
                  @click.prevent="activeStep -= 1"
                >
                  Back
                </b-button>
                <b-button
                  :disabled="!planDetailsEntered"
                  class="button"
                  icon-right="chevron-right"
                  @click.prevent="activeStep += 1"
                >
                  Continue
                </b-button>
              </div>
            </div>
          </b-step-item>
          <b-step-item
            label="Create Order"
            :type="{ 'is-success': true }"
            icon="plus"
          >
            <div class="mc-container">
              <div class="tile is-ancestor">
                <div class="tile is-vertical is-parent">
                  <div
                    v-if="order.plan"
                    class="tile is-child box"
                    :set="(plan = order.plan)"
                  >
                    <p class="title is-5">
                      Plan Deatils
                    </p>
                    <div class="media">
                      <div class="media-content">
                        <p class="subtitle is-7">Plan Name</p>
                        <p class="title is-6">
                          {{ plan.name }}
                        </p>
                      </div>
                      <div class="media-content">
                        <p class="subtitle is-7">No of Classes</p>
                        <p class="title is-6">
                          {{ plan.noOfClasses }}
                        </p>
                      </div>
                      <div class="media-content">
                        <p class="subtitle is-7">Plan Amount</p>
                        <p class="title is-6">
                          {{ displayAmount(order.plan.amount) }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="tile is-ancestor">
                <div class="tile is-vertical is-parent">
                  <div v-if="usersSelected" class="tile is-child box">
                    <p class="title is-5">
                      User Deatils
                    </p>
                    <div
                      v-for="user in order.users"
                      :key="user.objectID"
                      class="media"
                    >
                      <div class="media-content">
                        <p class="subtitle is-7">child Name</p>
                        <p class="title is-6">
                          {{ user.childName || 'No name' }}
                        </p>
                      </div>
                      <div class="media-content">
                        <p class="subtitle is-7">Guardian Name</p>
                        <p class="title is-6">
                          {{ user.guardianName || 'No name' }}
                        </p>
                      </div>
                      <div class="media-content">
                        <p class="subtitle is-7">Email</p>
                        <p class="title is-6">
                          {{ user.email || 'No Email' }}
                        </p>
                      </div>
                      <div class="media-content">
                        <p class="subtitle is-7">Mobile</p>
                        <p class="title is-6">
                          {{ user.phoneNumber || 'No mobile' }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="buttons">
                <b-button
                  class="button"
                  icon-left="chevron-left"
                  @click.prevent="activeStep -= 1"
                >
                  Back
                </b-button>
                <b-button
                  :disabled="!usersSelected || !planDetailsEntered"
                  :loading="orders.submitting"
                  type="is-primary"
                  @click.prevent="addOrdersHandler"
                >
                  Create Order
                </b-button>
              </div>
            </div>
          </b-step-item>
        </b-steps>
      </div>
    </mc-app-body>
  </fragment>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { Timestamp } from '../../firebase';

import { displayAmount } from './utils';
import { displayName } from '../../utils/user';

export default {
  data: function() {
    return {
      activeStep: 0,
      currency: '₹',
      order: {
        users: [],
        plan: {
          noOfClasses: 0,
          name: '',
          amount: 0
        }
      }
    };
  },
  computed: {
    ...mapState(['orders']),
    usersSelected() {
      return this.order.users.length !== 0;
    },
    planDetailsEntered() {
      return this.order.plan.noOfClasses && this.order.plan.name;
    }
  },
  methods: {
    ...mapActions('orders', ['addOrders']),
    displayName,
    displayAmount,
    getValidatedOrdersData() {
      // TODO Show Error if user has ongoing revenuecat Subscription.
      const ordersData = {};

      const errors = [];
      [('noOfClasses', 'name')].forEach(key => {
        if (!this.plan[key]) {
          errors.push(`${key} in plan section cannot be 0 or empty!`);
        }
      });

      if (errors.length) {
        this.$buefy.toast.open({
          message: 'Fix Errors: ' + errors.join(', '),
          type: 'is-danger'
        });
        return false;
      } else {
        ordersData.userIds = this.order.users.map(user => user.objectID);
        ordersData.plan = { ...this.order.plan };
      }
      return ordersData;
    },
    async addOrdersHandler() {
      const ordersData = this.getValidatedOrdersData();
      if (ordersData) {
        try {
          await this.addOrders(ordersData);
          this.$buefy.toast.open({
            message: 'Order created successfully!',
            type: 'is-success'
          });
          this.$router.replace(`/orders`);
        } catch (error) {
          this.$buefy.toast.open({
            message: 'Failed to create order!',
            type: 'is-danger'
          });
        }
      }
    }
  }
};
</script>

<style lang="scss">
.add-order {
  .step-details {
    margin-top: 2.5rem !important;
    .step-title {
      font-size: 1rem !important;
    }
  }
  .step-content {
    margin-top: 1rem;
  }
}
</style>
